const modMax = item => {
  return item.mod_max == null || `${item.mod_max}`.trim() == ''
    ? null
    : parseInt(item.mod_max, 10);
};

export default modMax;
